import { DataGrid } from 'app/components/data/'
import { MaterialInput, MaterialTextarea } from 'app/components/material'
import { filterAndSyncFoundationSource, FoundationSources, IFoundationData, setRequestAndSend } from 'app/components/section/FindAFoundation/DataSources';
import * as React from 'react'
import { Alert, Button, Col, Form, FormGroup, Modal, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { SendMailAction } from 'app/redux/SendMail/actions'

interface IFindAFoundationProps {
  className?: string
  onTableShow?: () => void
}

interface IFindAFoundationState {
  showTable: boolean
  showModal: boolean
  showSentMessage: boolean
  isSendingMessage: boolean
  requestUserName: string
  requestUserEmail: string
  requestUserMessage: string
  requestAcceptTerms: boolean
  foundationName: string
  foundationState: string
  foundationCity: string
  foundationZip: string
  foundation: IFoundationData
}

class FindAFoundation extends React.Component<IFindAFoundationProps, IFindAFoundationState> {

  state = {
    showTable: false,
    showModal: false,
    showSentMessage: false,
    isSendingMessage: false,
    requestUserName: '',
    requestUserEmail: '',
    requestUserMessage: '',
    requestAcceptTerms: false,
    foundation: null,
    foundationName: '',
    foundationState: '',
    foundationCity: '',
    foundationZip: '',
  }

  componentDidMount() {
    this.setState({ showTable: true })
    filterAndSyncFoundationSource('', '', '', '')
  }

  submitSearch(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    filterAndSyncFoundationSource(this.state.foundationName, this.state.foundationState, this.state.foundationCity, this.state.foundationZip)

    this.setState({ showTable: true }, () => {
      if (typeof this.props.onTableShow === 'function') {
        this.props.onTableShow()
      }
    })
  }

  openModal(foundation: IFoundationData, typeOfRequest: string) {
    const requestUserMessage = `I would like to receive ${typeOfRequest} on ${foundation.name} (${foundation.ein}) at ${foundation.location}.`

    this.setState({ showModal: true, requestUserMessage, foundation })
  }

  openRequestReportModal(foundation: IFoundationData) {
    return this.openModal(foundation, 'a report')
  }

  openRequestMoreInfoModal(foundation: IFoundationData) {
    return this.openModal(foundation, 'more info')
  }

  hideModal() {
    this.setState({
      showModal: false,
      showSentMessage: false,
      isSendingMessage: false,
      requestUserName: '',
      requestUserEmail: '',
      requestUserMessage: '',
      requestAcceptTerms: false,
    })
  }

  submitRequest(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    this.setState({ isSendingMessage: true })

    SendMailAction.sendEmail(this.state.requestUserName, this.state.requestUserEmail, this.state.requestUserMessage)
      .then((response) => {
        setRequestAndSend(this.state.foundation.ein, this.state.requestUserEmail)
        this.setState({ isSendingMessage: false })
        this.setState({ showSentMessage: true })
        this.state.requestUserEmail = ''
        this.state.requestUserName = ''
        this.state.requestUserMessage = ''
        setTimeout(() => {
          this.setState({ showSentMessage: false })
        }, 5000)
      })
      .catch((error) =>
        // tslint:disable-next-line:no-console
        console.log(error)
      )
  }

  handleOnKeyDown(e) {
    if (e.key === 'Enter') {
      filterAndSyncFoundationSource(this.state.foundationName, this.state.foundationState, this.state.foundationCity, this.state.foundationZip)

      this.setState({ showTable: true }, () => {
        if (typeof this.props.onTableShow === 'function') {
          this.props.onTableShow()
        }
      })
    }
  }

  renderCurrency(data) {
    return '$' + parseFloat(parseFloat(data.totalAssets).toFixed(1)).toLocaleString() + ' mm'
  }

  render() {
    return (
      <section className={this.props.className}>
        <Row>
          <Col sm={12} className="input-group" style={{ borderRadius: '5px', backgroundColor: '#fff' }}>
            <input className="input-group-addon" type="text" placeholder="Enter partial or full foundation name"
              onChange={(event) => this.setState({ foundationName: event.target.value })} onKeyDown={this.handleOnKeyDown.bind(this)}
              value={this.state.foundationName} style={{ padding: '15px', boxShadow: 'none', textAlign: 'left', WebKitBoxShadow: 'none', width: '100%' }} id="foundationName" />
            <span className="input-group-addon" style={{ borderLeft: '1px solid grey' }}><i className="fa fa-search"></i></span>
          </Col>
        </Row>
        <Row style={{ marginTop: '10px' }}>
          <Col sm={12} md={3} style={{ backgroundColor: '#1F5B8F', marginTop: '27px', borderRadius: '3px', color: '#fff' }}>
            <form style={{ padding: '5px' }} onSubmit={(e) => this.submitSearch(e)}>
              <div className="form-group">
                <label htmlFor="city">City:</label>
                <input type="text" onChange={(event) => this.setState({ foundationCity: event.target.value })} className="form-control" id="city" style={{ backgroundColor: '#fff' }} />
              </div>
              <div className="form-group">
                <label htmlFor="state">State (2 Characters):</label>
                <input type="text" onChange={(event) => this.setState({ foundationState: event.target.value })} className="form-control" id="state" style={{ backgroundColor: '#fff' }} />
              </div>
              <div className="form-group">
                <label htmlFor="zip">Zipcode:</label>
                <input type="text" onChange={(event) => this.setState({ foundationZip: event.target.value })} className="form-control" id="zip" style={{ backgroundColor: '#fff' }} />
              </div>
              <Button type="submit" block bsStyle="success" style={{ marginTop: 15 }}>
                <i className="fa fa-fw fa-search" />
                Search
              </Button>
            </form>
            <ul style={{ marginTop: '10px', padding: 'none' }}>
              <li>Enter foundation name, use City, State or Zipcode to narrow results if necessary</li>
              <li>Click the Search Button</li>
              <li>Find the foundation in the list</li>
              <li>Having trouble finding your foundation? Contact us below</li>
            </ul>
          </Col>
          <Col sm={12} md={9}>
            {
              this.state.showTable ?
                <section className="animated fadeIn margin-top" style={{ paddingBottom: 0 }}>
                  <DataGrid DataSource={FoundationSources}
                    pageSizes={[10, 15]}
                    columns={[
                      {
                        label: 'Total Assets', pathExpression: '$.totalAssets', customRender: (data, col) => (
                          <span>{this.renderCurrency(data)}</span>
                        )
                      },
                      {
                        label: 'Name', pathExpression: '$.name', customRender: (data, col) => (
                          //NOTE: hyperlinkn 
                          <a href="javascript:void(0)"
                            onClick={() => this.openRequestMoreInfoModal(data)}>
                            {data.name}
                          </a>
                        )
                      },
                      { label: 'Location', pathExpression: '$.location' },
                      { label: 'Latest Year End', pathExpression: '$.latestYearEnd' },
                    ]}
                  />
                </section>
                : <i className="fa fa-spinner fa-spin" style={{ fontSize: '48px', color: '#fff' }}></i>
            }
          </Col>
        </Row>
        <Modal show={this.state.showModal} onHide={this.hideModal.bind(this)}>
          <Modal.Header closeButton style={{ backgroundColor: '#2B76B8' }}>
            <Modal.Title style={{ color: '#fff' }}>Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={(e) => this.submitRequest(e)}>
              <FormGroup>
                <MaterialInput placeholder="Name" required
                  disabled={this.state.showSentMessage || this.state.isSendingMessage}
                  value={this.state.requestUserName}
                  onChange={(requestUserName) => this.setState({ requestUserName })} />
              </FormGroup>
              <FormGroup>
                <MaterialInput placeholder="Email" type="email" required
                  disabled={this.state.showSentMessage || this.state.isSendingMessage}
                  value={this.state.requestUserEmail}
                  onChange={(requestUserEmail) => this.setState({ requestUserEmail })} />
              </FormGroup>
              <FormGroup>
                <MaterialTextarea placeholder="Message" rows={3} required
                  disabled={this.state.showSentMessage || this.state.isSendingMessage}
                  value={this.state.requestUserMessage}
                  onChange={(requestUserMessage) => this.setState({ requestUserMessage })} />
              </FormGroup>
              <section style={{ overflowX: 'hidden' }}>
                {this.state.showSentMessage ?
                  <Alert bsStyle="success" className="animated fadeIn">
                    <header>
                      <strong>Your request has been sent!</strong>
                    </header>
                    <section>
                      A response will be sent to your email soon.&nbsp;
                      <a href="javascript:void(0)" onClick={() => this.hideModal()}>
                        Click here to close request.
                      </a>
                    </section>
                  </Alert>
                  :
                  <FormGroup>
                    <Row>
                      <Col sm={9}>
                        <label>
                          <input type="checkbox" required
                            disabled={this.state.showSentMessage || this.state.isSendingMessage}
                            value="true" />&nbsp;
                          <small>
                            <span>By requesting this I accept the&nbsp;</span>
                            <a href="/#/terms-of-use" target="_blank">
                              terms and conditions.
                            </a>
                          </small>
                        </label>
                      </Col>
                      <Col sm={3}>
                        <Button type="submit" bsStyle="success" block
                          disabled={this.state.showSentMessage || this.state.isSendingMessage}>
                          {this.state.isSendingMessage ?
                            <span>
                              Sending...
                            </span>
                            :
                            <span>
                              Send&nbsp;
                              <i className="fa fa-fw fa-send" />
                            </span>
                          }
                        </Button>
                      </Col>
                    </Row>
                  </FormGroup>
                }
              </section>
            </form>
          </Modal.Body>
          <Modal.Footer>
          </Modal.Footer>
        </Modal>

      </section>
    )
  }
}

export {
  FindAFoundation
}



// WEBPACK FOOTER //
// ./src/app/components/section/FindAFoundation/index.tsx